export const SORT_TYPES = {
  text: { asc: 'A \u2192 Z', desc: 'Z \u2192 A' },
  number: { asc: '1 \u2192 9', desc: '9 \u2192 1' },
};

export const BOOKING_CONTACTS_COLUMNS = [
  { id: 'name', label: 'Name', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'email', label: 'Email', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'phone', label: 'Phone', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'company_name', label: 'Company', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'contact_type', label: 'Type', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'offer_count', label: '# Offers', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'hold_count', label: '# Holds', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
  { id: 'confirm_count', label: '# Events', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'number' },
];

export const getDefaultVisibleColumns = () =>
  BOOKING_CONTACTS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  BOOKING_CONTACTS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
